import type { LexicalEditor } from 'lexical';

import { registerNodeTracking } from '../../utils/registerNodeTracking';
import { $isMentionNode, MentionNode, type MentionUser } from './MentionNode';

type Callbacks = {
  onAdded: (user: MentionUser) => void;
  onRemoved: (user: MentionUser) => void;
};

/**
 * Reports when a user becomes mentioned (their first mention) and stops being mentioned (their last one goes).
 * - Local edits only; see `registerNodeTracking`.
 */
export const registerMentionTracking = (editor: LexicalEditor, callbacks: Callbacks): (() => void) =>
  registerNodeTracking(
    editor,
    MentionNode,
    (node) => ($isMentionNode(node) ? node.getUser() : null),
    (user) => user.id,
    callbacks,
  );
